import Swiper, {Navigation} from 'swiper';
import 'swiper/css';

function initRatingSlider() {
  const selector = '.js-rating-slider';
  const prevSelector = '.js-rating-slider-prev';
  const nextSelector = '.js-rating-slider-next';

  const slider = document.querySelector(selector);

  if (!slider) return;

  Swiper.use([Navigation]);

  const swiper = new Swiper(slider, {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: nextSelector,
      prevEl: prevSelector,
    },
    breakpoints: {
      640: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });
}

export {initRatingSlider};
